var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 用户名密码 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }